import { Controller } from '@hotwired/stimulus';
import { application } from 'src';
import { find, findAll, getParent, isVisible } from '@fretadao/f-js-dom';
import { isBlank } from '@fretadao/f-js-utils';

/**
 * Used to manage routing request passenger form
**/
application.register('routing-request-passenger-form', class extends Controller {
  NAME_POSITION = 0;
  COST_CENTER_POSITION = 1;
  REQUEST_KIND_POSITION = 2;
  ADDRESS_KIND_POSITION = 3;
  ADDRESS_KINDS = {
    default: 'Padrão',
    custom: 'Customizado'
  };
  REQUEST_KINDS = {
    meal: 'Refeição',
    transport: 'Transporte',
    meal_and_transport: 'Transporte e refeição'
  };

  connect() {
    this.fieldNames = [
      'cost_center',
      'request_kind',
      'address_street',
      'address_number',
      'address_reference',
      'address_city',
      'address_state'
    ];
  }

  setCurrentEditingPassenger(event) {
    const editLink = event.target;
    const passengerRow = this.#passengerRow(editLink);
    const passengerCheckbox = this.#passengerCheckbox(passengerRow);

    this.#setCurrentEditingPassengerValue(passengerCheckbox, passengerRow);
    this.#fillPassengerForm(passengerCheckbox);
  }

  fillPassengerData() {
    this.#updatePassengerCheckBoxes();
    this.#updatePassengerRow();
  }

  #updatePassengerRow() {
    const passengerCheckboxes = findAll(`#${this.#currentEditingPassengerValue()}`);
     passengerCheckboxes.forEach(checkbox => {
       const tableRow = this.#tableRowFor(checkbox);
       const tableCells = this.#cellsFor(tableRow);
       const passengerData = this.#passengerData(checkbox);

       this.#updateCostCenter(tableCells[this.COST_CENTER_POSITION], passengerData['cost_center']);
       this.#updateRequestKind(tableCells[this.REQUEST_KIND_POSITION], passengerData['request_kind']);
       this.#updateAddressKind(tableCells[this.ADDRESS_KIND_POSITION], passengerData['address_street']);
       this.#highlighElement(tableRow);
     });
  }

  #updateCostCenter(tableCell, fieldData) {
    if (!isBlank(fieldData)) tableCell.innerHTML = fieldData;
  }

  #updateRequestKind(tableCell, fieldData) {
    if (!isBlank(fieldData)) tableCell.innerHTML = this.REQUEST_KINDS[fieldData];
  }

  #updateAddressKind(tableCell, fieldData) {
    const addressKind = isBlank(fieldData) ? 'default' : 'custom';
    tableCell.innerHTML = this.ADDRESS_KINDS[addressKind]
  }

  #updatePassengerCheckBoxes() {
    const passengerCheckboxes = findAll(`#${this.#currentEditingPassengerValue()}`);

    passengerCheckboxes.forEach(passengerCheckbox => {
      const passengerData = this.#passengerData(passengerCheckbox);
      this.fieldNames.forEach((fieldName) => passengerData[fieldName] = this.#formField(fieldName).value);
      passengerCheckbox.value = JSON.stringify(passengerData);
    });
  }

  #passengerRow(editLink) {
    const parentsQuantity = this.#isDesktopElement(editLink) ? 2 : 4;
    return getParent(editLink, parentsQuantity);
  }

  #passengerCheckbox(passengerRow) {
    return find('input[type=checkbox]', passengerRow);
  }

  #currentEditingPassengerTag() {
    return find('#current-editing-passenger');
  }

  #currentEditingPassengerNameTag() {
    return find('#passenger-data-form-passenger-name');
  }

  #setCurrentEditingPassengerValue(passengerCheckbox, passengerRow) {
    this.#currentEditingPassengerTag().innerHTML = passengerCheckbox.id;
    const passengerCells = this.#cellsFor(passengerRow);
    this.#currentEditingPassengerNameTag().innerHTML = passengerCells[this.NAME_POSITION].innerHTML;
  }

  #currentEditingPassengerValue() {
    return this.#currentEditingPassengerTag().innerHTML;
  }

  #fillPassengerForm(passengerCheckbox) {
    const passengerData = this.#passengerData(passengerCheckbox);

    this.fieldNames.forEach(fieldName => {
        const fieldData = passengerData[fieldName]
        this.#formField(fieldName).value = isBlank(fieldData) ? '' : fieldData;
      }
    );
  }

  #formField(name) {
    return find(`#routing_request_item_${name}`);
  }

  #passengerData(passengerCheckbox) {
    return JSON.parse(passengerCheckbox.value);
  }

  #isDesktopElement(element) {
    return getParent(element).tagName === 'TD';
  }

  #tableRowFor(checkbox) {
    return this.#isDesktopElement(checkbox) ? getParent(checkbox, 2) : getParent(checkbox, 3).lastElementChild;
  }

  #highlighElement(element) {
    if (isVisible(element)) {
      element.animate([ { opacity: 0 }, { opacity: 1 } ], { duration: 3000, delay: 500 });
    }
  }

  #cellsFor(tableRow) {
    return findAll('p', tableRow);
  }
});
